var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { RampInstantSDK } from '@ramp-network/ramp-instant-sdk';
import { Network, OnRampAsset, OnRampProvider, getPortalBaseURL } from '@usecapsule/web-sdk';
import { getChainId, getContractAddressFromAsset, getCurrencyCodes, reverseCurrencyLookup, offRampSend, } from '../utils/index.js';
const TEST_MODE_FORBIDDEN = ['ETH_ETH', 'ETH_USDC'];
export const RampEmbed = ({ capsule, appName, onRampConfig, onRampPurchase, isEmbedded, apiKey, onClose, setOnRampPurchase, }) => {
    const { currencyCodes } = getCurrencyCodes(onRampConfig, {
        provider: OnRampProvider.RAMP,
        purchaseType: onRampPurchase.type,
        walletType: onRampPurchase.walletType,
    });
    const isMounted = useRef(false);
    useEffect(() => {
        if (!isMounted.current) {
            try {
                const widget = new RampInstantSDK({
                    hostAppName: appName,
                    swapAsset: currencyCodes.filter(code => !onRampPurchase.testMode || !TEST_MODE_FORBIDDEN.includes(code)).join(','),
                    fiatValue: onRampPurchase.fiatQuantity,
                    fiatCurrency: onRampPurchase.fiat,
                    hostLogoUrl: `${getPortalBaseURL(capsule.ctx)}/wordmark_black.svg`,
                    hostApiKey: apiKey,
                    userAddress: onRampPurchase.address,
                    userEmailAddress: capsule.getEmail(),
                    url: (onRampPurchase === null || onRampPurchase === void 0 ? void 0 : onRampPurchase.testMode) ? 'https://app.demo.ramp.network' : 'https://app.ramp.network',
                    enabledFlows: [onRampPurchase.type === 'BUY' ? 'ONRAMP' : 'OFFRAMP'],
                    useSendCryptoCallback: true,
                    variant: 'embedded-mobile',
                    containerNode: document.getElementById('ramp-container'),
                })
                    .on('PURCHASE_CREATED', (e) => __awaiter(void 0, void 0, void 0, function* () {
                    const p = e.payload.purchase;
                    const [network, asset] = onRampPurchase.testMode
                        ? [Network.ETHEREUM, OnRampAsset.ETHEREUM]
                        : reverseCurrencyLookup(onRampConfig.assetInfo, OnRampProvider.RAMP, p.asset.symbol) || [];
                    const updated = yield capsule.ctx.capsuleClient.updateOnRampPurchase({
                        userId: capsule.getUserId(),
                        walletId: onRampPurchase.walletId,
                        externalWalletAddress: onRampPurchase.externalWalletAddress,
                        purchaseId: onRampPurchase.id,
                        updates: {
                            providerKey: p.id,
                            fiatQuantity: p.fiatValue,
                            fiat: p.fiatCurrency,
                            assetQuantity: p.cryptoAmount,
                            asset,
                            network,
                        },
                    });
                    setOnRampPurchase(updated);
                }))
                    .on('WIDGET_CLOSE', () => __awaiter(void 0, void 0, void 0, function* () {
                    onClose === null || onClose === void 0 ? void 0 : onClose();
                    if (!isEmbedded) {
                        setTimeout(() => {
                            window.close();
                        }, 5000);
                    }
                }))
                    .onSendCrypto((assetInfo, amount, address) => __awaiter(void 0, void 0, void 0, function* () {
                    try {
                        const [network, asset] = reverseCurrencyLookup(onRampConfig.assetInfo, OnRampProvider.RAMP, assetInfo.symbol);
                        const txHash = yield offRampSend(capsule, onRampPurchase, setOnRampPurchase, {
                            assetQuantity: amount,
                            destinationAddress: address,
                            contractAddress: getContractAddressFromAsset(network, asset),
                            chainId: getChainId(network),
                            testMode: onRampPurchase.testMode,
                        });
                        return { txHash };
                    }
                    catch (e) {
                        console.error(e);
                    }
                }));
                widget.show();
                isMounted.current = true;
            }
            catch (e) {
                console.error(e);
            }
        }
    }, []);
    return _jsx("div", { id: "ramp-container", style: { minWidth: '320px', width: '100%', height: '767px' } });
};
